export const schema = {
  type: 'object',
  properties: {
    formData: { type: 'object' },
    fileName: { type: 'string' },
    recordType: { type: 'string' },
    recordId: { type: 'string' },
    recordExtension: { type: 'string' },
    schemaName: { type: 'string' },
    schemaVersion: { type: 'string' },
    recordName: { type: 'string' }, // deprecated
    origin: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['new', 'imported'] },
        registeredChildDois: { type: 'array', items: { type: 'string' } },
        resourceFieldsImported: {
          type: 'object',
          properties: {
            funding: { type: 'boolean' },
            license: { type: 'boolean' },
            simCheckUrl: { type: 'boolean' },
            relationships: { type: 'boolean' },
            references: { type: 'boolean' },
            chapters: {
              type: 'object',
              additionalProperties: {
                type: 'object',
                properties: {
                  references: { type: 'boolean' },
                },
                required: ['references'],
                additionalProperties: false,
              },
            },
          },
          additionalProperties: false,
        },
      },
      required: ['type'],
      additionalProperties: false,
    },
  },
  required: [
    'formData',
    'fileName',
    'recordType',
    'recordId',
    'recordExtension',
    'schemaName',
    'schemaVersion',
  ],
  additionalProperties: false,
};
